import React, { ComponentProps, PropsWithChildren } from 'react'

import { bemJoin } from 'bem-join'
import classnames from 'classnames'

export type PageContentProps = ComponentProps<'div'>

const b = bemJoin('lawyer-page')

export const PageContent = ({
  children,
  className,
  ...rest
}: PropsWithChildren<PageContentProps>) => {
  return (
    <div className={classnames(b('content'), className)} {...rest}>
      {children}
    </div>
  )
}
